import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'user', method: 'POST', body: body, token: token })
}
